<template>
  <div class="nav-menu-container fit-height print-hide">
    <div id="box-logo">
      <img src="/ModaNet/Scripts/assets/images/Moda-net.png" alt="Moda Net" />
    </div>
    <div class="nav-menu">
      <ul class="nav-menu-ul">        
        <MenuItem v-for="menuitem in Menu" 
          :key="menuitem.Id" 
          :menuitem="menuitem"
          :selectedId="SelectedId"
          :OpenFolder="OpenFolder" />        
      </ul>
    </div>
  </div>
</template>

<script>
import MenuItem from "./MenuItem";
import { mapState } from "vuex";

export default {
  name: "Menu",
  components: { MenuItem },
  async mounted() {    
    await this.$store.dispatch("menu/loadMenu")
  },
  computed: {
    ...mapState({
      Menu: state => state.menu.Menu,
      SelectedId: state => state.menu.SelectedId,
      OpenFolder: state => state.menu.OpenFolder
    })
  }
};
</script>
<style scoped>
  .nav-menu {
    height: calc(100% - 40px);
    overflow: auto;
  }
</style>